import { Form, useFormikContext } from 'formik';

import { Button } from '../../cdl/Button/Button';
import { DrawerContentLayout } from '../../cdl/Drawer/DrawerContentLayout';
import { FormikDebug } from '../../common/form-elements/formik/FormikDebug';
import { translate } from '../../common/helpers/translate.helper';

import { FormikEditUserState } from './EditUserForm';
import { EditUserFormContent } from './EditUserFormContent';

interface EditUserBaseFormProps {
    primaryActionText?: string;
}

export const EditUserBaseForm = ({ primaryActionText = translate('user.updateMember') }: EditUserBaseFormProps) => {
    const { isSubmitting, dirty } = useFormikContext<FormikEditUserState>();

    return (
        <Form style={{ height: '100%', minHeight: 0 }}>
            <DrawerContentLayout
                isBusy={isSubmitting}
                hasUnsavedChanges={dirty}
                primaryAction={
                    <Button type="submit" emphasis="high" isLoading={isSubmitting}>
                        {primaryActionText}
                    </Button>
                }
            >
                <EditUserFormContent />
                <FormikDebug />
            </DrawerContentLayout>
        </Form>
    );
};
